<script>
import VueChartJs from 'vue-chartjs'

export default {
  extends: VueChartJs.Line,
  props: ['patientID', 'options'],
  mixins: [VueChartJs.mixins.reactiveProp],
  data () {
    return {
    }
  },
  methods: {
  },
  async mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Patient/LineChart.vue